import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _assign from "lodash/assign";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as EasyAsync from 'redux-easy-async';
import { JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE } from "../constants";
export var createAsyncAction = function createAsyncAction(actionName, fn, options) {
  return EasyAsync.createAsyncAction(actionName, fn, _objectSpread({
    namespace: JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE
  }, options));
};
var OPTIMISTIC_NAMESPACE = 'OPTIMISTIC_NAMESPACE';

var createOptimisticConstants = function createOptimisticConstants(type) {
  return {
    getType: function getType() {
      return "OPTIMISTIC_".concat(type);
    },
    ROLLBACK_TYPE: "ROLLBACK_".concat(type),
    COMMIT_TYPE: "COMMIT_".concat(type),
    NAMESPACE: OPTIMISTIC_NAMESPACE
  };
};

var OPTIMISTIC_ERRORS = {
  ACTION_NOT_OBJECT: 'createOptimisticAction(type, fn): fn must return an object',
  DO_WORK_NOT_FUNCTION: 'createOptimisticAction(type, fn, doWork): call must have a doWork function'
};
export var decorateOptimisticAction = function decorateOptimisticAction(action, optimisticConstants, doWork) {
  _assign(action, _objectSpread(_objectSpread({}, optimisticConstants), {}, {
    doWork: doWork
  }));
};
export var createOptimisticAction = function createOptimisticAction(type, fn, doWork) {
  if (typeof doWork !== 'function') {
    throw new Error(OPTIMISTIC_ERRORS.DO_WORK_NOT_FUNCTION);
  }

  var optimisticConstants = createOptimisticConstants(type);

  var actionCreator = function actionCreator() {
    var optimisticAction = fn.apply(void 0, arguments);

    if (_typeof(optimisticAction) !== 'object') {
      throw new Error(OPTIMISTIC_ERRORS.ACTION_NOT_OBJECT);
    }

    var _optimisticAction$pay = optimisticAction.payload,
        payload = _optimisticAction$pay === void 0 ? {} : _optimisticAction$pay,
        _optimisticAction$rol = optimisticAction.rollback,
        rollback = _optimisticAction$rol === void 0 ? {} : _optimisticAction$rol,
        _optimisticAction$com = optimisticAction.commit,
        commit = _optimisticAction$com === void 0 ? {} : _optimisticAction$com,
        _optimisticAction$eff = optimisticAction.effect,
        effect = _optimisticAction$eff === void 0 ? {} : _optimisticAction$eff;
    return {
      type: optimisticConstants.getType(),
      payload: payload,
      meta: {
        offline: {
          effect: effect,
          rollback: {
            type: optimisticConstants.ROLLBACK_TYPE,
            meta: rollback
          },
          commit: {
            type: optimisticConstants.COMMIT_TYPE,
            meta: commit
          }
        }
      }
    };
  };

  decorateOptimisticAction(actionCreator, optimisticConstants, doWork);
  return actionCreator;
};
export var isOptimisticAction = function isOptimisticAction(action) {
  return action && action.NAMESPACE === OPTIMISTIC_NAMESPACE && action.COMMIT_TYPE && action.ROLLBACK_TYPE;
};
/**
 * Parses a GraphQL error for important fields.
 *
 * @param {*} error GraphQLError
 */

export var parseGraphQLErrorDetails = function parseGraphQLErrorDetails() {
  var _response$body, _response$body$error;

  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extensions = error.extensions,
      errorMessage = error.message;
  var response = extensions === null || extensions === void 0 ? void 0 : extensions.response;
  var responseData = response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : (_response$body$error = _response$body.error) === null || _response$body$error === void 0 ? void 0 : _response$body$error.data;
  return {
    responseData: responseData,
    code: extensions === null || extensions === void 0 ? void 0 : extensions.code,
    url: response === null || response === void 0 ? void 0 : response.url,
    httpStatusCode: response === null || response === void 0 ? void 0 : response.status,
    systemErrorCode: response === null || response === void 0 ? void 0 : response.statusText,
    internalMessage: (responseData === null || responseData === void 0 ? void 0 : responseData.internal_message) || errorMessage,
    userMessage: responseData === null || responseData === void 0 ? void 0 : responseData.user_message
  };
};